"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.SVGmn = void 0;
var Wrapper_js_1 = require("../Wrapper.js");
var mn_js_1 = require("../../common/Wrappers/mn.js");
var mn_js_2 = require("../../../core/MmlTree/MmlNodes/mn.js");
var SVGmn = (function (_super) {
    __extends(SVGmn, _super);
    function SVGmn() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SVGmn.kind = mn_js_2.MmlMn.prototype.kind;
    return SVGmn;
}(mn_js_1.CommonMnMixin(Wrapper_js_1.SVGWrapper)));
exports.SVGmn = SVGmn;
//# sourceMappingURL=mn.js.map